import { BrowserRouter, Routes, Route } from "react-router-dom";

import { observer } from "mobx-react";

import ErrorBoundary from "./components/ErrorBoundary";
import Page404 from "./pages/Page404";
import Translate from "./pages/Translate";
import ClientError from "./pages/ClientError";
import LoginPage from "./pages/LoginPage";

import './App.css';
import './Scrollbars.css';
import './components/ContextMenu/_context-menu.scss';

declare global {
  interface Window {
    user?: { role: string; tokensLeft: number; picture?: string; name?: string; given_name?: string; family_name?: string; email: string; emailMd5: string; id: string };
  }
}

const App = observer(() => {
  const isLoggedIn = !!window.user;

  return (
    <BrowserRouter>
      <ErrorBoundary fallback={(e) => <ClientError error={e} />}>
        <Routes>
          {!isLoggedIn ? (
            <Route path="*" element={<LoginPage />} />
          ) : (
            <>
              <Route path="/" element={<Translate />} />
              <Route path="*" element={<Page404 />} />
            </>
          )}
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
});

export default App;